import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class DeviceConstantsService {

	constructor(
		private translate: TranslateService,
	) { }
	readonly SERIAL_NUMBER_PATTERN = /^V(00|10)(0[1-9]|1[0-2])[2-9][0-9][01]\d{4}$/;

	remoteServerOptions = [
		{
			label: 'Production',
			value: 'devices.sctvmspro.com',
			port: 9749,
		},
		{
			label: 'Staging',
			value: 'devices.sctvmspro.com',
			port: 9748,
		},
		{
			label: 'Development',
			value: 'vmspro.iotah-view.org',
			port: 9153,
		}
	];

	readonly SHIPMENT_MIN_VOLTAGE = 20;
	readonly SHIPMENT_STATUS = {
		ready: { key: this.translate.instant('shipment.ready'), status: 0 },
		not_started: { key: this.translate.instant('shipment.not_started'), status: 1 },
		in_progress: { key: this.translate.instant('shipment.in_progress'), status: 2 },
		completed: { key: this.translate.instant('shipment.completed'), status: 3 },
		not_connected: { key: this.translate.instant('shipment.device_is_disconnected'), status: 4 },
		not_in_cm: { key: this.translate.instant('shipment.not_in_cm'), status: 5 },
		invalid_voltage: { key: this.translate.instant('shipment.invalid_voltage'), status: 6 },
		invalid_water_level: { key: this.translate.instant('shipment.invalid_water_level'), status: 7 },
		no_cm_po_number: { key: this.translate.instant('shipment.no_cm_po_number'), status: 8 },
		cellular_iccid_does_not_exist: { key: this.translate.instant('shipment.cellular_iccid_does_not_exist'), status: 9 },
		invalid_temperature: { key: this.translate.instant('shipment.invalid_temperature'), status: 10 },
	};

	readonly SHIPMENT_RESULT = {
		NOT_TESTED: 0,
		PASSED: 1,
		FAILED: 2
	};

	readonly cycleStatesOptions = [
		{ value: 1, label: 'devices.cycle_states.idle' },
		{ value: 2, label: 'devices.cycle_states.charge' },
		{ value: 3, label: 'devices.cycle_states.cooling_down' },
		{ value: 4, label: 'devices.cycle_states.cooldown_done' }
	];

	readonly roamingStatusOptions = [
		{ value: 1, label: 'devices.roaming_statuses.local' },
		{ value: 5, label: 'devices.roaming_statuses.roaming' }
	];

	readonly configAccessTechOptions = [
		{ value: 0, label: 'devices.access_tech.gsm' },
		{ value: 1, label: 'devices.access_tech.umts' },
		{ value: 2, label: 'devices.access_tech.gsm_umts_automatic' },
		{ value: 3, label: 'devices.access_tech.gsm_umts_gsm_prefer' },
		{ value: 4, label: 'devices.access_tech.gsm_umts_umts_prefer' },
		{ value: 5, label: 'devices.access_tech.lte' },
		{ value: 6, label: 'devices.access_tech.gsm_lte_automatic' },
		{ value: 7, label: 'devices.access_tech.gsm_lte_gsm_prefer' },
		{ value: 8, label: 'devices.access_tech.gsm_lte_lte_prefer' },
		{ value: 9, label: 'devices.access_tech.umts_lte_automatic' },
		{ value: 10, label: 'devices.access_tech.umts_lte_umts_prefer' },
		{ value: 11, label: 'devices.access_tech.umts_lte_lte_prefer' },
		{ value: 12, label: 'devices.access_tech.gsm_umts_lte_automatic' },
		{ value: 13, label: 'devices.access_tech.gsm_umts_lte_gsm_prefer' },
		{ value: 14, label: 'devices.access_tech.gsm_umts_lte_umts_prefer' },
		{ value: 15, label: 'devices.access_tech.gsm_umts_lte_lte_prefer' },
		{ value: 16, label: 'devices.access_tech.gsm_lte_dual_link' },
		{ value: 17, label: 'devices.access_tech.umts_lte_dual_link' },
		{ value: 18, label: 'devices.access_tech.gsm_umts_lte_dual_link' },
		{ value: 19, label: 'devices.access_tech.catm_bg95' },
		{ value: 20, label: 'devices.access_tech.gsm_catm_bg95' },
		{ value: 21, label: 'devices.access_tech.catnb_bg95' },
		{ value: 22, label: 'devices.access_tech.gsm_catnb_bg95_bc32' },
		{ value: 23, label: 'devices.access_tech.catm_catnb_bg95' },
		{ value: 24, label: 'devices.access_tech.gsm_catm_catnb_bg95' },
		{ value: 25, label: 'devices.access_tech.catm_gsm_bg95' },
		{ value: 26, label: 'devices.access_tech.catnb_gsm_bg95_bc32' },
		{ value: 27, label: 'devices.access_tech.catnb_catm_bg95' },
		{ value: 28, label: 'devices.access_tech.gsm_catnb_catm_bg95' },
		{ value: 29, label: 'devices.access_tech.catm_gsm_catnb_bg95' },
		{ value: 30, label: 'devices.access_tech.catm_catnb_gsm_bg95' },
		{ value: 31, label: 'devices.access_tech.catnb_gsm_catm_bg95' },
		{ value: 32, label: 'devices.access_tech.catnb_catm_gsm_bg95' },
		{ value: 33, label: 'devices.access_tech.catnb_gsm_enterprise_bc32' }
	];

	readonly ratOptions = [
		{ value: 0, label: 'devices.rat_keys.gsm' },
		{ value: 1, label: 'devices.rat_keys.gsm_compact' },
		{ value: 2, label: 'devices.rat_keys.utran' },
		{ value: 3, label: 'devices.rat_keys.gsm_wegprs' },
		{ value: 4, label: 'devices.rat_keys.utran_whsdpa' },
		{ value: 5, label: 'devices.rat_keys.utran_whsupa' },
		{ value: 6, label: 'devices.rat_keys.utran_whsdpa_hsupa' },
		{ value: 7, label: 'devices.rat_keys.e_utran' },
		{ value: 8, label: 'devices.rat_keys.utran_hspap' },
		{ value: 9, label: 'devices.rat_keys.e_utran_ca' },
		{ value: 10, label: 'devices.rat_keys.e_utran_nbiot' },
		{ value: 11, label: 'devices.rat_keys.e_utran_emtc' },
		{ value: 12, label: 'devices.rat_keys.none' }
	];

	readonly deviceStageOptions = [
		{ value: 0, label: 'devices.device_stages.cm' },
		{ value: 1, label: 'devices.device_stages.sct_inventory' },
		{ value: 2, label: 'devices.device_stages.bwt' },
		{ value: 3, label: 'devices.device_stages.demo_and_engineering' }
	];

	readonly DeviceStage ={
		CM: 0,
		SCT_INVENTORY: 1,
		CLIENT: 2,
		DEMO_ENGINEERING: 3
	}

	readonly ratMap = {
		'gsm': 0,
		'gsm_compact': 1,
		'utran': 2,
		'gsm_wegprs': 3,
		'utran_whsdpa': 4,
		'utran_whsupa': 5,
		'utran_whsdpa_hsupa': 6,
		'e_utran': 7,
		'utran_hspap': 8,
		'e_utran_ca': 9,
		'e_utran_nbiot': 10,
		'e_utran_emtc': 11,
		'none': 12
	};

	readonly configAccessTech: { [key: string]: number } = {
		'gsm': 0,
		'umts': 1,
		'gsm_umts_automatic': 2,
		'gsm_umts_gsm_prefer': 3,
		'gsm_umts_umts_prefer': 4,
		'lte': 5,
		'gsm_lte_automatic': 6,
		'gsm_lte_gsm_prefer': 7,
		'gsm_lte_lte_prefer': 8,
		'umts_lte_automatic': 9,
		'umts_lte_umts_prefer': 10,
		'umts_lte_lte_prefer': 11,
		'gsm_umts_lte_automatic': 12,
		'gsm_umts_lte_gsm_prefer': 13,
		'gsm_umts_lte_umts_prefer': 14,
		'gsm_umts_lte_lte_prefer': 15,
		'gsm_lte_dual_link': 16,
		'umts_lte_dual_link': 17,
		'gsm_umts_lte_dual_link': 18,
		'catm_bg95': 19,
		'gsm_catm_bg95': 20,
		'catnb_bg95': 21,
		'gsm_catnb_bg95_bc32': 22,
		'catm_catnb_bg95': 23,
		'gsm_catm_catnb_bg95': 24,
		'catm_gsm_bg95': 25,
		'catnb_gsm_bg95_bc32': 26,
		'catnb_catm_bg95': 27,
		'gsm_catnb_catm_bg95': 28,
		'catm_gsm_catnb_bg95': 29,
		'catm_catnb_gsm_bg95': 30,
		'catnb_gsm_catm_bg95': 31,
		'catnb_catm_gsm_bg95': 32,
		'catnb_gsm_enterprise_bc32': 33
	};

	readonly roamingStatus = {
		'local': 1,
		'roaming': 5
	};

	readonly cycleStates = {
		'idle': 1,
		'charge': 2,
		'cooling_down': 3,
		'cooldown_done': 4
	};
}
